import { LyneFieldError } from "components/Lyne/LyneFieldError";
import { FieldError } from "react-hook-form";

interface HookFormErrorProps {
  error: FieldError | undefined;
}

export const HookFormError: React.FC<HookFormErrorProps> = ({ error }) => {
  if (!error) {
    return null;
  }

  return <LyneFieldError error={error.message} />;
};
